import apiFetch from '../apiFetch'

export default function (token, documentId) {
  return apiFetch({ endPoint: `documentHistorical/${documentId}/sheet`, method: 'GET', body: null, token: token })
}
